import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Alert, Button, InputLabel, MenuItem, Select, Paper } from '@mui/material';
import moment from 'moment';
import styles from './table.module.css';
import color from 'color'

function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits({ res, result }) {
  if (res.length === 0)
    return <></>
  if (result === 0)
    return <></>
  return (
    < React.Fragment >

      {/*<Typography style={{ textAlign: 'center' }} variant="h5">Order Details</Typography>
      <br />
       <Paper style={{ padding: '10px', backgroundColor: 'seashell' }}>
        <Typography variant="h6"><strong>Name:</strong>&nbsp; {res[0].name}</Typography>
        <br />
        <Typography variant="h6"><strong>Reg No.:</strong>&nbsp; {res[0].reg_id}</Typography>
        <br />
        <Typography variant="h6"><strong>Trees Sowed:</strong>&nbsp; {res[0].count}</Typography>
        <br />
      </Paper> */}

      <table className={styles.table}>
        <thead>
          <tr>
            <th colSpan={5} style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}><Typography variant="h7">Trees Sowed:&nbsp; {res[0].count}</Typography></th>
          </tr>
          <tr>
            <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Sr. No.</th>
            <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Plantation Id</th>
            <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Reg Id</th>
            <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>No. of Trees</th>
            <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Plantation Date</th>
          </tr>
        </thead>
        <tbody>
          {result.map((ele, i) => (
            <tr>
              <td>{i + 1}</td>
              <td>{ele.order_id}</td>
              <td>{ele.reg_id}</td>
              <td>{ele.no_of_trees}</td>
              <td>{moment(ele.created_at).format('Do MMMM YYYY')}</td>
            </tr>
          ))}
        </tbody>
      </table>


    </React.Fragment >
  );
}